<template>
  <div class="vx-row">
        <div class="pricing pricing-palden mb-0 mt-4">
          <div class="pricing-item features-item ja-animate pricing__item--featured" data-animation="move-from-bottom" data-delay="item-1" style="min-height: 497px;">
            <div class="pricing-deco bg-warning-gradient">
              <svg class="pricing-deco-img" enable-background="new 0 0 300 100" height="100px" id="Layer_1" preserveAspectRatio="none" version="1.1" viewBox="0 0 300 100" width="300px" x="0px" xml:space="preserve" y="0px">
                        <path class="deco-layer deco-layer--1" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z" fill="#FFFFFF" opacity="0.6"></path>
                <path class="deco-layer deco-layer--2" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z" fill="#FFFFFF" opacity="0.6"></path>
                <path class="deco-layer deco-layer--3" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716H42.401L43.415,98.342z" fill="#FFFFFF" opacity="0.7"></path>
                <path class="deco-layer deco-layer--4" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z" fill="#FFFFFF"></path>
                    </svg>
              <div class="pricing-price"><span class="pricing-currency">Desde $ </span>{{ planData[1].price_per_renew.toLocaleString('en-US') }}
                <span class="pricing-period">/mes</span>
              </div>
              <h3 class="mb-5 text-white">Plan Profesional</h3>
            </div>

            <ul class="list pl-5 pr-3 mt-text2">

              <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-warning" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </span>
                <span class="text-left">
                  30 Firmas incluidos al mes
                </span>
              </li>

              <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-4 text-warning" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </span>
                <span class="text-left">
                  Funcionalidades avanzadas

                  <ul>
                  <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-warning" svgClasses="w-3 h-3 text-warning"></feather-icon>
                    </span>
                    Firma Ordenada
                  </li>
                  <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-warning" svgClasses="w-3 h-3 text-warning"></feather-icon>
                    </span>
                    Validación de RFC o CURP de firmantes
                  </li>
                     <li class="list__item">
                    <span class="w-5 h-5 mr-1 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-warning" svgClasses="w-3 h-3 text-warning"> </feather-icon>
                    </span>
                     Hoja de firmas con logo  o sin el logo de Verificamex
                  </li>

                    <li class="list__item">
                    <span class="w-5 h-5 feather-icon select-none relative">
                       <feather-icon icon="CircleIcon" class="top-3 text-warning" svgClasses="w-3 h-3 text-warning"> </feather-icon>
                    </span>
                    Recordatorios personalizados
                  </li>
                </ul>
                </span>

              </li>

              <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-4" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </span>
                <span class="text-left">
                  Soporte preferente
                <vx-tooltip text="Vía chat, correo y teléfono" class="d-inline-block" position="top">
                  <feather-icon icon="HelpCircleIcon" class="top-4 text-primary" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </vx-tooltip>
                </span>
              </li>
              <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-warning" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </span>
                <span class="text-left">
                  Descuento preferencial en firmas adicionales
                </span>
              </li>

              <li class="list__item">
                <span class="w-5 h-5 mr-2 feather-icon select-none relative">
                  <feather-icon icon="CheckIcon" class="top-3 text-warning" svgClasses="w-5 h-5 text-warning"></feather-icon>
                </span>
                <span class="text-left">
                  Cargo recurrente
                </span>
              </li>

            </ul>

            <vs-button v-if="userPlan.name !== 'Plan Profesional'" class="mt-butom mx-5 flex-b-ad w-90 font-w-600" color="warning" @click="goToPlans">Contratar ahora</vs-button>
            <vs-button v-if="userPlan.name === 'Plan Profesional'" class="mt-butom mx-5 flex-b-ad w-90 font-w-600 btn-secundary" to="/buy/documents">Comprar firmas adicionales</vs-button>
            <p class="text-docs">Comprar Firmas adicionales <a href="/buy/documents" target="_blank">ver paquetes.</a></p>

          </div>
        </div>
  </div>
</template>

<script>

export default{
  props: ['upgradeProPopup'],
  computed: {
    planData() {
      return this.$store.state.plans.plan.data;
    },
    userPlan() {
      return this.$store.state.account.user.me.plan;
    }
  },
  methods: {
    goToPlans() {
      let routeData = this.$router.resolve({name: 'buy-plans'});
      window.open(routeData.href, '_blank');
    },
    switchPlan(planId, planName) {

      let instance = this;
      if (planId === 3) {
        this.upgradeProPopup(false);
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirmación`,
          text: 'Todas las firmas adicionales compradas en el transcurso de tu plan profesional se perderan ¿Estás seguro de cambiar al plan ' + planName + '?',
          acceptText: "Si",
          cancelText: "No",
          accept: function () {
            instance.$vs.loading({type: "point"})
            instance.$store.dispatch("plans/switchPlan", {planId: planId, aclChangeRole: this.$acl.change})
              .then(
                () => {
                  instance.$vs.loading.close()
                  instance.$store.dispatch("alert/success", "El plan se ha cambiado éxitosamente", {root: true});
                },
                error => {
                  instance.$vs.loading.close()
                }
              )
          }
        })
      } else {
        this.upgradeProPopup(false);
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirmación`,
          text: '¿Estás seguro de cambiar al ' + planName + '?',
          acceptText: "Si",
          cancelText: "No",
          accept: function () {
            instance.$vs.loading({type: "point"})
            instance.$store.dispatch("plans/switchPlan", {planId: planId, aclChangeRole: this.$acl.change})
              .then(
                () => {
                  instance.$vs.loading.close()
                  instance.$store.dispatch("alert/success", "El plan se ha cambiado éxitosamente", {root: true});
                },
                error => {
                  instance.$vs.loading.close()
                }
              )
          }
        })
      }
    }
  },
  created() {
    this.$store.dispatch("plans/getAll", {});
  }
}
</script>

<style>
.corpo{
  font-size: 3em!important;
}
section {
  padding: 2em 0 8em;

  position: relative;
  -webkit-font-smoothing: antialiased;
}

.pricing {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto 3em;
}

.pricing-item {
  position: relative;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: stretch;
  align-items: stretch;
  text-align: center;
  -webkit-flex: 0 1 400px;
  flex: 0 1 400px;
}

.pricing-action {
  color: inherit;
  border: none;
  background: none;
  cursor: pointer;
}

.pricing-action:focus {
  outline: none;
}

.pricing-feature-list {
  text-align: left!important;

}

.pricing-palden .pricing-item {
  min-width: 370px;
  cursor: default;
  background: #fff;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  -webkit-transition: all .3s ease-in-out;
  border-radius: 20px 20px 10px 10px;
  margin: 1em;
}

@media screen and (min-width: 66.25em) {
  .pricing-palden .pricing-item {
    margin: 1em -0.5em;
  }
  .pricing-palden .pricing__item--featured {
    margin: 0;
    z-index: 10;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s ease-in-out;
  }
}

.pricing-palden .pricing-deco {
  border-radius: 10px 10px 0 0;
  background: linear-gradient(135deg,#4097f9,#0af0c7);
  padding: 2em 0 4.5em;
  position: relative;
}

.pricing-palden .pricing-deco-img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px!important;
}

.pricing-palden .pricing-title {
  margin-bottom: 15px;
  font-size: 0.75em;
  text-transform: uppercase;
  letter-spacing: 5px;
  color: #fff;
}

.pricing-palden .deco-layer {
  -webkit-transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
}

.pricing-palden .pricing-item:hover .deco-layer--1 {
  -webkit-transform: translate3d(15px, 0, 0);
  transform: translate3d(15px, 0, 0);
}

.pricing-palden .pricing-item:hover .deco-layer--2 {
  -webkit-transform: translate3d(-15px, 0, 0);
  transform: translate3d(-15px, 0, 0);
}

.pricing-palden .icon {
  font-size: 2.5em;
}

.pricing-palden .pricing-price {
  font-size: 4em;
  font-weight: bold;
  padding: 0;
  color: #fff;
  margin: 0 0 0.25em 0;
  line-height: 0.75;
}

.pricing-palden .pricing-currency {
  font-size: 0.35em;
  vertical-align: top;
}

.pricing-palden .pricing-period {
  font-size: 0.25em;
  padding: 0 0 0 0;
  font-style: italic;
}

.pricing-palden .pricing__sentence {
  font-weight: bold;
  margin: 0 0 1em 0;
  padding: 0 0 0.5em;
}

.pricing-palden .pricing-feature-list {
  margin: 0;
  padding: 0.25em 0 2.5em;
  list-style: none;
  text-align: center;
}

.pricing-palden .pricing-feature {
  padding-bottom: 1.3em;
  padding-left: 2.5em;
}

.pricing-palden .pricing-action {
  font-weight: bold;
  margin: auto 3em 2em 3em;
  padding: 1em 2em;
  color: #fff;
  border-radius: 30px;
  background: linear-gradient(135deg,#a93bfe,#584efd);
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

.pricing-palden .pricing-action:hover,
.pricing-palden .pricing-action:focus {
  background: linear-gradient(135deg,#fd7d57,#f55d59);
}

.pricing-palden .pricing-item--featured .pricing-deco {
  padding: 5em 0 8.885em 0;
}
.mt-butom{
  margin-top: 3.5rem !important;
}
.flex-b{
  position: absolute;
  bottom: 35px;
  width: 85%;
}
.flex-b-ad{
  position: absolute!important;
  bottom: 35px!important;
}
.text-docs{
  position: absolute;
  bottom: 8px;
  left: 24px;
  font-size: 12.5px;
}

.mt-text2{
  margin-top: -2.8rem !important;
  z-index: 9!important;
}
.mt-text{
  margin-top: -1.8rem !important;
  z-index: 9!important;
}
</style>

